import perkakas from '../../assets/home/icons/perkakas.png';
import lantai from '../../assets/home/icons/lantai.png';
import pintu_jendela from '../../assets/home/icons/pintu_jendela.png';
import elektronik from '../../assets/home/icons/elektronik.png';
import toilet from '../../assets/home/icons/toilet.png';
import plumbing from '../../assets/home/icons/plumbing.png';
import listrik from '../../assets/home/icons/listrik.png';
import cat from '../../assets/home/icons/cat.png';
import lem_bahan_kimia from '../../assets/home/icons/lem_bahan_kimia.png';
import atap from '../../assets/home/icons/atap.png';
import besi from '../../assets/home/icons/besi.png';
import bahan_alam from '../../assets/home/icons/bahan_alam.png';
import bahan_bangunan from '../../assets/home/icons/bahan_bangunan.png';

const data = [
    {
        id: 1,
        heading: 'Bahan Bangunan',
        content: 'Kami menyediakan berbagai bahan bangunan berkualitas tinggi seperti semen, pasir, batu bata, beton untuk mendukung proyek konstruksi Anda.',
        to: '/',
        icon: bahan_bangunan,
    },
    {
        id: 2,
        heading: 'Bahan Alam',
        content: 'Temukan bahan-bahan alam seperti batu alam, kerikil, kayu, dan bambu yang cocok untuk keperluan dekorasi dan konstruksi ramah lingkungan.',
        to: '/',
        icon: bahan_alam,
    },
    {
        id: 3,
        heading: 'Besi',
        content: 'Jual berbagai jenis besi seperti besi beton, baja ringan, wiremesh, dan plat besi untuk kebutuhan struktur bangunan Anda.',
        to: '/',
        icon: besi,
    },
    {
        id: 4,
        heading: 'Atap',
        content: 'Tersedia pilihan atap berkualitas mulai dari atap seng, genteng metal, hingga atap polycarbonate untuk berbagai jenis bangunan.',
        to: '/',
        icon: atap,
    },
    {
        id: 5,
        heading: 'Lem & Bahan Kimia',
        content: 'Kami menyediakan lem bangunan, waterproofing, cat pelapis anti bocor, dan bahan kimia lainnya untuk kebutuhan konstruksi Anda.',
        to: '/',
        icon: lem_bahan_kimia,
    },
    {
        id: 6,
        heading: 'Cat',
        content: 'Dapatkan berbagai pilihan cat interior dan eksterior, cat kayu dan besi, serta perlengkapan mengecat lainnya dengan kualitas terbaik.',
        to: '/',
        icon: cat,
    },
    {
        id: 7,
        heading: 'Listrik',
        content: 'Sediakan semua kebutuhan instalasi listrik seperti kabel, saklar, lampu, stop kontak, dan panel listrik hanya di sini.',
        to: '/',
        icon: listrik,
    },
    {
        id: 8,
        heading: 'Plumbing',
        content: 'Perlengkapan pipa, keran, selang, sambungan, dan alat plumbing lainnya tersedia untuk sistem air bersih dan buangan.',
        to: '/',
        icon: plumbing,
    },
    {
        id: 9,
        heading: 'Sanitari',
        content: 'Tersedia produk sanitasi seperti kloset, wastafel, shower, dan aksesoris kamar mandi lainnya dengan desain modern dan fungsional.',
        to: '/',
        icon: toilet,
    },
    {
        id: 10,
        heading: 'Elektronik',
        content: 'Kami juga menyediakan berbagai peralatan elektronik rumah tangga seperti kipas angin, dispenser, dan pemanas air.',
        to: '/',
        icon: elektronik,
    },
    {
        id: 11,
        heading: 'Pintu & Jendela',
        content: 'Pilih berbagai jenis pintu dan jendela dari bahan kayu, aluminium, dan UPVC untuk keamanan dan estetika rumah Anda.',
        to: '/',
        icon: pintu_jendela,
    },
    {
        id: 12,
        heading: 'Lantai & Dinding',
        content: 'Lengkapi rumah Anda dengan ubin keramik, granit, marmer, dan material pelapis dinding berkualitas tinggi.',
        to: '/',
        icon: lantai,
    },
    {
        id: 13,
        heading: 'Perkakas',
        content: 'Berbagai alat pertukangan dan perkakas rumah tangga seperti bor, palu, obeng, dan lainnya tersedia untuk menunjang pekerjaan Anda.',
        to: '/',
        icon: perkakas,
    },
]

export default data;